import React from 'react'
import Svg from '../../../../packages/uikit/src/components/Svg/Svg'
import { SvgProps } from '../../../../packages/uikit/src/components/Svg/types'

const Icon: React.FC<SvgProps> = (props) => (
  <Svg width="24" height="20" viewBox="0 0 24 20" fill="none" {...props}>
    <path
      d="M11.9915 3.19477C12.0375 3.13624 12.0682 3.08747 12.1072 3.04845C12.5768 2.57886 13.038 2.10091 13.5229 1.64664C14.3646 0.859337 15.3637 0.367448 16.4966 0.169577C19.7252 -0.391985 22.7016 1.68705 23.3398 4.7638C23.7718 6.84144 23.2437 8.69055 21.7457 10.2038C18.5435 13.4367 15.3135 16.6444 12.0974 19.8633C12.0612 19.8995 12.0361 19.9441 11.9943 19.9998C11.933 19.9413 11.8926 19.9051 11.855 19.8675C10.4295 18.4419 9.00396 17.0178 7.57985 15.5923C5.79762 13.8129 4.01957 12.0335 2.23873 10.254C1.52946 9.54474 1.01946 8.71424 0.725441 7.75415C0.541505 7.15496 0.452324 6.54045 0.466259 5.91479C0.528964 3.11813 2.43382 0.92483 4.87794 0.276873C5.47434 0.118019 6.08188 0.0483467 6.69779 0.0845766C8.20272 0.172364 9.50421 0.736713 10.5827 1.79435C11.0105 2.21378 11.43 2.64157 11.855 3.06378C11.8898 3.10001 11.9274 3.13346 11.9915 3.19477Z"
      fill={props.fill || 'white'}
    />
  </Svg>
)

export default Icon
